import axios from 'axios';
import { AppConfig } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const appConfigApi = {
    getAppConfig: async (): Promise<AppConfig> => {
        const response = await axios.get(`${API_URL}/config`, {
            headers: getAuthHeader(),
        });
        return response.data;
    },

    updateAppConfig: async (config: AppConfig): Promise<AppConfig> => {
        const response = await axios.put(`${API_URL}/config`, config, {
            headers: getAuthHeader(),
        });
        return response.data;
    },
};
